/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Form, Field } from 'react-final-form';
import { updateRecommendationSettings, getRecommendationPreviews } from 'Shared/actions/organizations';
import CreateableInputOnly from 'Shared/components/CreateableInputOnly';
import Switcher from 'Dashboard/Switcher/Switcher';
import { recommendationKlassDisplayName } from 'Shared/helpers';
import PreviewModal from './components/PreviewModal/PreviewModal';
import Select from 'react-select';
import WpIcon from 'Wpds/components/icon/WpIcon';

import './SalesSettingsPanel.scss';

const formMutators = {
  setAllNotificationTrueMutator: (args, state, utils) => {
    utils.changeValue(state, 'alert:email', () => true);
    utils.changeValue(state, 'alert:slack', () => true);
    utils.changeValue(state, 'alert:web', () => true);
  },
};

// TODO: Pass the recommendation into component to avoid this duplication...
function description(recommendationKlassName) {
  return {
    'Recommendation::SalesforceOpportunityPastDue':
      "Alert representatives when their opportunity's close date has not been met",
    'Recommendation::SalesforceContactNeedsCreation':
      'Alert representatives when they’re communicating with an external person who does not exist as a contact or lead in Salesforce',
    'Recommendation::SalesforceOpportunityNeedsUpdate':
      "Alert representatives when they've had a meeting but haven’t updated the corresponding opportunity",
    'Recommendation::SalesforceOpportunityNeedsNewActivity':
      'Alert representatives when an opportunity has not been updated in a long time',
    'Recommendation::SalesforceOpportunityStageNeedsUpdate':
      'Alert representatives when an opportunity stays in a stage for too long',
    'Recommendation::SalesforceOpportunityCloseDateNeedsUpdate':
      'Alert representatives if their opportunity’s close date is coming up soon but they haven’t interacted with any contacts for the opportunity recently',
    'Recommendation::SalesforceLeadNeedsEmail':
      'Alerts representatives if a lead has gone too long without ever being contacted',
  }[recommendationKlassName];
}

class RecommendationSettingsPanel extends Component {
  state = { showPreviewModal: false, showDetails: false };

  get initialValues() {
    const { settings } = this.props;
    return Object.fromEntries(
      settings.map(setting => [
        setting.key,
        typeof setting.value === 'number' ? setting.value.toString() : setting.value,
      ])
    );
  }

  showPreviewModal = form_values => {
    const { dispatch, recommendation_klass_name } = this.props;
    dispatch(getRecommendationPreviews(recommendation_klass_name, form_values));
    this.setState({ showPreviewModal: true });
  };

  toggleshowDetails = () => {
    const { recommendation_klass_name, history, recommendation_setting_id } = this.props;
    if (recommendation_klass_name === 'Recommendation::SalesforceGenericRecordAlert') {
      history.push(`/assistants/sales/rule_builder/${recommendation_setting_id}`);
    } else {
      this.setState(prevState => ({ showDetails: !prevState.showDetails }));
    }
  };

  togglePreviewModal = () => this.setState(prevState => ({ showPreviewModal: !prevState.showPreviewModal }));

  renderButtonEnabledRecommendationProperty(setting) {
    const { label, key } = setting;
    return (
      <div className="d-flex justify-content-start">
        <Field name={key} className="mt-1" component="input" type="checkbox" />

        <div className="ml-2">
          <p className="font-weight-bold mb-0">{label}</p>
        </div>
      </div>
    );
  }

  renderRecommendationProperty(setting, form_values) {
    const { recommendation_klass_name } = this.props;
    const { unit, parameter, label, min_value, max_value, key, type } = setting;

    if (recommendation_klass_name === 'Recommendation::SalesforceOpportunityPastDue') {
      return (
        <>
          <div className="form-inline">
            <p className="mb-0 mr-1">
              Trigger if <b>{parameter}</b> is
            </p>
            <Field
              id={key}
              name={key}
              className="form-control"
              component="input"
              type="number"
              min={min_value}
              max={max_value}
            />
            <p className="mb-0 ml-1">{unit}</p>
          </div>
          <small className="text-muted">
            Must be between {min_value} and {max_value}
          </small>
        </>
      );
    }
    if (recommendation_klass_name === 'Recommendation::SalesforceOpportunityNeedsUpdate') {
      return (
        <>
          <div className="form-inline">
            <p className="mb-0 mr-1">Trigger if {parameter} hasn't been updated in</p>
            <Field
              id={key}
              name={key}
              className="form-control"
              component="input"
              type="number"
              min={min_value}
              max={max_value}
            />
            <p className="mb-0 ml-1">{unit}</p>
          </div>
          <small className="text-muted">
            Must be between {min_value} and {max_value}{' '}
          </small>
        </>
      );
    }
    if (recommendation_klass_name === 'Recommendation::SalesforceOpportunityNeedsNewActivity') {
      return (
        <>
          <div className="form-inline">
            <p className="mb-0 mr-1">Trigger if {parameter} hasn't been updated in</p>
            <Field
              id={key}
              name={key}
              className="form-control"
              component="input"
              type="number"
              min={min_value}
              max={max_value}
            />
            <p className="mb-0 ml-1">{unit}</p>
          </div>
          <small className="text-muted">
            Must be between {min_value} and {max_value}{' '}
          </small>
        </>
      );
    }
    if (
      recommendation_klass_name === 'Recommendation::SalesforceOpportunityStageNeedsUpdate' &&
      key.startsWith('no_stage_change_threshold:')
    ) {
      const ignore = form_values[key.replace('no_stage_change_threshold', 'ignore_stage')];
      return (
        <>
          <div className="form-inline" style={ignore ? { opacity: 0.5 } : {}}>
            <p className="mb-0 mr-1">
              <b>{parameter}</b> for
            </p>
            <Field
              id={key}
              name={key}
              className="form-control"
              component="input"
              type="number"
              min={min_value}
              max={max_value}
              disabled={ignore}
            />
            <p className="mb-0 ml-1">{unit}</p>
          </div>
          <small className="text-muted">
            Must be between {min_value} and {max_value}{' '}
          </small>
        </>
      );
    }
    if (
      recommendation_klass_name === 'Recommendation::SalesforceOpportunityStageNeedsUpdate' &&
      key === 'custom_message'
    ) {
      return (
        <>
          <div style={{ width: '600px' }}>
            <Field
              id={key}
              name={key}
              className="form-control"
              component="textarea"
              maxLength="5000"
              parse={value => value}
            />
            <p className="mb-0 ml-1">{unit}</p>
          </div>
        </>
      );
    }
    if (recommendation_klass_name === 'Recommendation::SalesforceContactNeedsCreation' && key === 'domain_blacklist') {
      return (
        <>
          <div>
            <p className="mb-0 mr-1">Ignore for people with these email addresses or email domains:</p>
            <p />

            <Field name={key} id={key} parse={value => value}>
              {({ input: { onChange, value } }) => (
                <div>
                  <CreateableInputOnly onChange={onChange} value={value} />
                </div>
              )}
            </Field>
          </div>
        </>
      );
    }
    if (
      recommendation_klass_name === 'Recommendation::SalesforceContactNeedsCreation' &&
      key === 'last_touchpoint_threshold'
    ) {
      return (
        <>
          <div className="form-inline">
            <p className="mb-0 mr-1">Trigger if {parameter} with person was within</p>
            <Field
              id={key}
              name={key}
              className="form-control"
              component="input"
              type="number"
              min={min_value}
              max={max_value}
            />
            <p className="mb-0 ml-1">{unit}</p>
          </div>
          <small className="text-muted">
            Must be between {min_value} and {max_value}{' '}
          </small>
        </>
      );
    }
    if (recommendation_klass_name === 'Recommendation::SalesforceOpportunityCloseDateNeedsUpdate') {
      return (
        <>
          <div className="form-inline">
            <p className="mb-0 mr-1">
              Trigger if <b>{parameter}</b> is
            </p>
            <Field
              id={key}
              name={key}
              className="form-control"
              component="input"
              type="number"
              min={min_value}
              max={max_value}
            />
            <p className="mb-0 ml-1">{unit}</p>
          </div>
          <small className="text-muted">
            Must be between {min_value} and {max_value}{' '}
          </small>
        </>
      );
    }

    if (type == 'boolean') {
      return (
        <div className="d-flex justify-content-start">
          <div className="mr-2">
            <p>{label}</p>
          </div>

          <Field name={key} className="mt-1" component="input" type="checkbox" />
        </div>
      );
    }

    if (setting.type === 'select') {
      return (
        <div className="d-flex justify-content-start">
          <div className="mr-2">
            <p>{label}</p>
          </div>

          <Field name={setting.key} id={setting.key} parse={value => value.value}>
            {({ input: { onChange, value } }) => {
              return (
                <div style={{ width: '180px', display: 'inline-block' }}>
                  <Select
                    value={setting.options.find(option => option.value === value)}
                    onChange={onChange}
                    options={setting.options}
                  />
                </div>
              );
            }}
          </Field>
        </div>
      );
    }

    return (
      <div>
        <div>{label}</div>
        <Field name={key} component="input" type="number" min={min_value} max={max_value} />
        <div>
          <small>
            Must be between {min_value} and {max_value}
          </small>
        </div>
      </div>
    );
  }

  handleSettingsSubmit = settings => {
    const { dispatch, recommendation_setting_id } = this.props;
    dispatch(updateRecommendationSettings({ [recommendation_setting_id]: settings }));
  };

  handleActiveToggle = ({ value, onChange, setAllNotificationTrueMutator, onSubmit }) => () => {
    // if (!value) { setAllNotificationTrueMutator(); }
    onChange(!value);
    onSubmit();
  };

  render() {
    const {
      class_specific_settings,
      customMessage,
      emailAlert,
      messageImage,
      webAlert,
      slackAlert,
      actionButtonsEnabled,
      isActive,
      settings,
      recommendation_klass_name,
      recommendation_setting_name,
      recommendation_previews,
      recommendation_previews_loading,
      recommendation_previews_requests_pending,
    } = this.props;
    const { showPreviewModal, showDetails } = this.state;

    return (
      <div className="row mb-2 sales-settings-panel">
        <div className="col-12">
          <div className="card">
            <Form
              initialValues={this.initialValues}
              mutators={{ ...formMutators }}
              onSubmit={this.handleSettingsSubmit}
              render={({
                dirty,
                handleSubmit,
                values,
                form: {
                  mutators: { setAllNotificationTrueMutator },
                },
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="card-header">
                    <div className="d-flex">
                      <div className="mr-4" style={{ width: '50px' }}>
                        <button type="button" className="btn" onClick={this.toggleshowDetails}>
                          <WpIcon name={showDetails ? 'angle-down' : 'angle-right'} size="lg" />
                        </button>
                      </div>
                      <div>
                        <h4>{recommendationKlassDisplayName(recommendation_setting_name)}</h4>
                        <p className="text-muted mb-0">{description(recommendation_klass_name)}</p>
                      </div>
                      <div className="d-flex align-items-center" style={{ marginLeft: 'auto' }}>
                        <Field name="active" parse={value => value}>
                          {({ input: { onChange, value } }) => {
                            const switcher_id = `switcher-${recommendationKlassDisplayName(recommendation_setting_name)
                              .toLowerCase()
                              .replace(/ /g, '-')}`;
                            return (
                              <Switcher
                                id={switcher_id}
                                checked={value}
                                onChange={this.handleActiveToggle({
                                  value,
                                  onChange,
                                  setAllNotificationTrueMutator,
                                  onSubmit: handleSubmit,
                                })}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                  </div>

                  {showDetails && (
                    <div className="card-body">
                      {class_specific_settings && class_specific_settings.length > 0 ? (
                        <p className="font-weight-bold">1. Set Trigger</p>
                      ) : null}

                      {class_specific_settings && class_specific_settings.length > 0 && (
                        <ul className="list-group mb-4">
                          {recommendation_klass_name === 'Recommendation::SalesforceOpportunityStageNeedsUpdate' && (
                            <li className="list-group-item justify-content-between">
                              <p className="mb-0">Trigger if the opportunity is stuck in:</p>
                            </li>
                          )}

                          {class_specific_settings &&
                            class_specific_settings.map(setting => (
                              <li className="list-group-item justify-content-between" key={setting.key}>
                                {this.renderRecommendationProperty(setting, values)}
                              </li>
                            ))}
                        </ul>
                      )}

                      {actionButtonsEnabled && actionButtonsEnabled.length > 0 && (
                        <div>
                          {class_specific_settings.length > 0 ? (
                            <p className="font-weight-bold">2. Choose which action buttons are enabled</p>
                          ) : (
                            <p className="font-weight-bold">2. Choose which action buttons are enabled</p>
                          )}
                          <ul className="list-group mb-4">
                            {actionButtonsEnabled.map(setting => (
                              <li className="list-group-item justify-content-between" key={setting.key}>
                                {this.renderButtonEnabledRecommendationProperty(setting)}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {customMessage && (
                        <div>
                          <p className="font-weight-bold">3. Choose a custom message to show in the nudge (optional)</p>
                          {this.renderRecommendationProperty(customMessage, values)}
                        </div>
                      )}

                      <div className="row mt-2">
                        <div className="col-sm-4">
                          <button type="submit" className="btn btn-primary mr-3" disabled={!dirty}>
                            Save Changes
                          </button>
                          <button
                            type="button"
                            onClick={() => this.showPreviewModal(values)}
                            className="btn btn-secondary mr-4"
                          >
                            Preview
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              )}
            />
            <PreviewModal
              onToggle={this.togglePreviewModal}
              isOpen={showPreviewModal}
              displayName={recommendationKlassDisplayName(recommendation_setting_name)}
              onDoneClick={this.togglePreviewModal}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  class_specific_settings: ownProps.settings.filter(
    setting =>
      setting.key !== 'custom_message' &&
      setting.key !== 'description' &&
      !setting.key.startsWith('button_enabled:') &&
      setting.key !== 'message_image' &&
      setting.key !== 'tags_whitelist' &&
      setting.key !== 'active' &&
      !['alert:email', 'alert:web', 'alert:slack'].includes(setting.key)
  ),
  isActive: ownProps.settings.find(s => s.key === 'active').value,
  emailAlert: ownProps.settings.find(s => s.key === 'alert:email'),
  slackAlert: ownProps.settings.find(s => s.key === 'alert:slack'),
  webAlert: ownProps.settings.find(s => s.key === 'alert:web'),
  customMessage: ownProps.settings.find(s => s.key === 'custom_message'),
  actionButtonsEnabled: ownProps.settings.filter(s => s.key.startsWith('button_enabled:')),
  messageImage: ownProps.settings.find(s => s.key === 'message_image'),
  recommendation_previews: state.recommendation_previews.data,
  recommendation_previews_loading: state.recommendation_previews.loading,
  recommendation_previews_requests_pending:
    state.recommendation_previews.requested_users &&
    state.recommendation_previews.requested_users.length !== state.recommendation_previews.received_users.length,
});

export default withRouter(connect(mapStateToProps)(RecommendationSettingsPanel));
